class BaseService {
  constructor(name = 'base-service') {
    this.name = name;
    this.site = BC.site.code;
  }

  doRequest(opts) {
    return new Promise((resolve, reject) => {
      $.ajax(opts)
        .then(data => resolve(data))
        .fail((jqXHR, textStatus, error) => {
          const {
            readyState,
            responseJson,
            responseText,
            status,
          } = jqXHR;

          $.error(`textStatus: ${textStatus} errorThrown: ${error} serviceUrl: ${opts.url}
                   readyState: ${readyState} status: ${status} responseText: ${responseText}
                   responseJSON: ${JSON.stringify(responseJson)}`, this.name);

          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ jqXHR, textStatus, error });
        });
    });
  }
}

export default BaseService;
